/**
 * @param {MediaSubFile} mediaSubFile
 * @return {string}
 */
export default (mediaSubFile) => {
  return mediaSubFile.externalLink.replace('vindex.json', `f${mediaSubFile.firstFrame}.jpg`);
};
